module.exports = __webpack_public_path__ + "static/media/covid-19.8f44164d.png";